import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { AppSettings } from '../../sharedcomponents/_common/constants/app.constants';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { SpanishCharConverstion } from '../../sharedcomponents/commonservice/SpanishTextHandling.service';
import { User } from '../../models/user/user';
import { UserGioLocation } from '../../models/user/usergioLocation';
import { geolocation } from '../../sharedcomponents/commonservice/geolocation/geoloc';
import { Ng2DeviceService } from 'ng2-device-detector';
declare var CryptoService: any;
@Injectable()
export class UserService {
  cryptoService: any;
  userGioLocation: UserGioLocation;
  constructor(private http: Http, private utilserv: utilityService, private spanishConvert: SpanishCharConverstion, private deviceService: Ng2DeviceService, private geoloc: geolocation) {
    this.cryptoService = new CryptoService();
  }

  private prepareEnvelopeForGetUserDetail() {
    var envelope =
      '<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/" xmlns:ice="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common.Contract">';
    envelope += '<soapenv:Header/>';
    envelope += '<soapenv:Body>';
    envelope += '<tem:RequestBase>';
    envelope += '<tem:KeyUID>' + this.utilserv.isNull(sessionStorage.KeyUID) + '</tem:KeyUID>';
    envelope += '<tem:LanguageCode>' + this.utilserv.isNull(sessionStorage.langCode) + '</tem:LanguageCode>';
    envelope += '<tem:Session>';
    envelope += '<ice:T1>' + this.utilserv.isNull(sessionStorage.T1) + '</ice:T1>';
    envelope += '<ice:T2>' + this.utilserv.isNull(sessionStorage.T2) + '</ice:T2>';
    envelope += '</tem:Session>';
    envelope += '</tem:RequestBase>';
    envelope += '</soapenv:Body>';
    envelope += '</soapenv:Envelope>';
    return envelope;
  }

  registerUser(user: User) {

    return this.utilserv.soapPostwithoutAction(this.envelopUserReg(user), AppSettings.ICEUserMgmtService);
  }

  SendRegistrationCode(user: User) {
    return this.utilserv.soapPostwithoutAction(this.envelopSendRegistrationCode(user), AppSettings.ICEUserMgmtService);
  }
  private envelopSendRegistrationCode(user: User) {
    // if (sessionStorage.iovationBBKey != '' && localStorage.sessionId != '') {
    const DeviceDetail = this.deviceService.getDeviceInfo();
    let userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      userGioLocation = data;
    });
    if (localStorage.sessionId != '') {
      const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
      <s:Header>
        <a:Action s:mustUnderstand="1">http://tempuri.org/IICEUserMgmt/SendRegistrationCode</a:Action>
        <a:MessageID>urn:uuid:ca496002-610c-4e73-8de8-95babcfc18c5</a:MessageID>
        <a:ReplyTo>
          <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
        </a:ReplyTo>
      </s:Header>
      <s:Body>
        <CustomerInfoRequest xmlns="http://tempuri.org/">
          <AdditionalLastName i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <Address xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common.Contract" i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <Checksum i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <CustomerEmail i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <CustomerEmployer i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <CustomerOccupation i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <CustomerPwd i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <DOB i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <DeviceDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:Appversion>${AppSettings.Appversion}</d4p1:Appversion>
            <d4p1:DeviceBrowser>${DeviceDetail.browser}</d4p1:DeviceBrowser>
            <d4p1:DeviceID>${localStorage.sessionId}</d4p1:DeviceID>
            <d4p1:DeviceOS>${DeviceDetail.os}</d4p1:DeviceOS>
            <d4p1:DeviceOS_version>${DeviceDetail.os_version}</d4p1:DeviceOS_version>
            <d4p1:DeviceType>${DeviceDetail.device}</d4p1:DeviceType>
            <d4p1:DeviceUserAgent>${DeviceDetail.userAgent}</d4p1:DeviceUserAgent>
            <d4p1:EndIPAddress>${sessionStorage.EndUserIP}</d4p1:EndIPAddress>
            <d4p1:Latitude>${userGioLocation.latitude}</d4p1:Latitude>
            <d4p1:Longitude>${userGioLocation.longitude}</d4p1:Longitude>
            <d4p1:Platform>${AppSettings.Platform}</d4p1:Platform>
          </DeviceDetails>
          <DeviceID>${localStorage.sessionId}</DeviceID>
          <FirstName i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <IsBeingLinked>false</IsBeingLinked>
          <KeyUID i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <LanguageCode>${this.utilserv.isNull(sessionStorage.langCode)}</LanguageCode>
          <LastName i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <LastOrderNumber i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
         <LoyaltyCardNumber i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <MarketingBalance i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <MiddleName i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <MobileNumber i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <PreferCountryCode i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <ReceivingAgentId i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <ReferralCode i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <ReferredByCustomerId>0</ReferredByCustomerId>
          <RegistrationCode>${this.utilserv.isNull(user.RegistrationCode)}</RegistrationCode>
          <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common.Contract" i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <UserID i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
          <UserVerifiedBy i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
        </CustomerInfoRequest>
      </s:Body>
    </s:Envelope>
    `;

      return envelope;
    }
  }

  editrUser(user: User) {
    return this.utilserv.soapPostwithoutAction(this.envelopEditUser(user), AppSettings.ICEUserMgmtService);
  }
  editrUserupoloadImage(user: User) {
    return this.utilserv.soapPostwithoutAction(this.envelopEditUseruploadImage(user), AppSettings.ICEUserMgmtService);
  }

  getUserDocumets() {
    return this.utilserv.soapPostwithoutAction(this.envelopGetUserImage(), AppSettings.ICEDocumentMgmt);
  }

  private envelopUserReg(user: User) {
    const DeviceDetail = this.deviceService.getDeviceInfo();
    let userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      userGioLocation = data;
    });
    if (localStorage.sessionId != '') {
      const envelope = `<s:Envelope
                            xmlns:a="http://www.w3.org/2005/08/addressing"
                            xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                            <s:Header>
                              <a:Action s:mustUnderstand="1">http://tempuri.org/IICEUserMgmt/UserRegistration</a:Action>
                              <a:MessageID>urn:uuid:679a37cc-f18b-4fe1-9530-47d33b718a2e</a:MessageID>
                              <a:ReplyTo>
                                <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                              </a:ReplyTo>
                            </s:Header>
                            <s:Body>
                              <CustomerInfoRequest
                                xmlns="http://tempuri.org/">
                                <AdditionalLastName>${this.spanishConvert.removeDiacritics(this.utilserv.isNull(user.additionalLastName), true)}</AdditionalLastName>
                                <Address>
                                  <Address1></Address1>
                                  <CityCode></CityCode>
                                  <CountryCode></CountryCode>
                                  <StateCode></StateCode>
                                  <ZipCode></ZipCode>
                                </Address>
                                <Checksum></Checksum>
                                <CustomerEmail>${this.utilserv.isNull(user.email)}</CustomerEmail>
                                <CustomerEmployer></CustomerEmployer>
                                <CustomerOccupation></CustomerOccupation>
                                <CustomerPwd>${this.cryptoService.RSAEncrypt(user.password, sessionStorage.publicKeyRSA)}</CustomerPwd>
                                <DOB></DOB>
                                <DeviceDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                  <d4p1:Appversion>${AppSettings.Appversion}</d4p1:Appversion>
                                  <d4p1:DeviceBrowser>${DeviceDetail.browser}</d4p1:DeviceBrowser>
                                  <d4p1:DeviceID>${localStorage.sessionId}</d4p1:DeviceID>
                                  <d4p1:DeviceOS>${DeviceDetail.os}</d4p1:DeviceOS>
                                  <d4p1:DeviceOS_version>${DeviceDetail.os_version}</d4p1:DeviceOS_version>
                                  <d4p1:DeviceType>${DeviceDetail.device}</d4p1:DeviceType>
                                  <d4p1:DeviceUserAgent>${DeviceDetail.userAgent}</d4p1:DeviceUserAgent>
                                  <d4p1:EndIPAddress>${sessionStorage.EndUserIP}</d4p1:EndIPAddress>
                                  <d4p1:Latitude>${userGioLocation.latitude}</d4p1:Latitude>
                                  <d4p1:Longitude>${userGioLocation.longitude}</d4p1:Longitude>
                                  <d4p1:Platform>${AppSettings.Platform}</d4p1:Platform>
                                </DeviceDetails>
                                <DeviceID>${localStorage.sessionId}</DeviceID>
                                <FirstName>${this.spanishConvert.removeDiacritics(this.utilserv.isNull(user.firstName), true)}</FirstName>
                                <IsEmailNew>${user.IsEmailNew}</IsEmailNew>
                                <IsPhoneNew>${user.IsPhoneNew}</IsPhoneNew>
                                <KeyUID>${this.utilserv.isNull(sessionStorage.KeyUID)}</KeyUID>
                                <LanguageCode>${this.utilserv.isNull(sessionStorage.langCode)}</LanguageCode>
                                <LastName>${this.spanishConvert.removeDiacritics(this.utilserv.isNull(user.lastName), true)}</LastName>
                                <LastOrderNumber></LastOrderNumber>
                                <LoyaltyCardNumber>${this.utilserv.isNull(user.loyaltyCardNumber)}</LoyaltyCardNumber>
                                <MiddleName>${this.utilserv.isNull(user.middleName)}</MiddleName>
                                <MobileNumber>${this.utilserv.isNull(user.mobile)}</MobileNumber>
                                <PreferCountryCode>${this.utilserv.isNull(user.countryPreference)}</PreferCountryCode>
                                <ReceivingAgentId></ReceivingAgentId>
                                <ReferralCode>${this.utilserv.isNull(user.referCode)}</ReferralCode>
                                <RegistartionCode></RegistartionCode>
                                <Session
                                  xmlns="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common.DataContract">
                                  <T1></T1>
                                  <T2></T2>
                                </Session>
                                <UserID></UserID>
                                <UserVerifiedBy>${this.utilserv.isNull(user.methodName)}</UserVerifiedBy>
                              </CustomerInfoRequest>
                            </s:Body>
                          </s:Envelope>`;

      return envelope;
    }
  }
  //Envolpe for edit user
  private envelopEditUser(user: User) {
    if (localStorage.sessionId != '') {
      let envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                                                                             <s:Header>
                                                                               <a:Action s:mustUnderstand="1">http://tempuri.org/IICEUserMgmt/ChangeProfile</a:Action>
                                                                              <a:MessageID>urn:uuid:535b3369-ffc4-4a2c-b0a0-7a6bd23d64e8</a:MessageID>
                                                                               <a:ReplyTo>
                                                                                 <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                                                                               </a:ReplyTo>
                                                                             </s:Header>
                                                                             <s:Body>
                                                                               <CustomerInfoRequest xmlns="http://tempuri.org/">
                                                                                 <AdditionalLastName>${this.spanishConvert.removeDiacritics(
        this.utilserv.isNull(user.additionalLastName.trim()),
        true
      )}</AdditionalLastName>
                                                                                <Address xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common.Contract" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                                                                  <d4p1:Address1>${this.utilserv.isNull(user.address.trim())}</d4p1:Address1>
                                                                                  <d4p1:CityCode>${user.city}</d4p1:CityCode>
                                                                                  <d4p1:CountryCode>${user.country}</d4p1:CountryCode>
                                                                                  <d4p1:StateCode>${user.state}</d4p1:StateCode>
                                                                                  <d4p1:StateName>${user.stateName}</d4p1:StateName>
                                                                                  <d4p1:ZipCode>${user.zipcode}</d4p1:ZipCode>
                                                                                </Address>
                                                                                 <CustomerEmail>${user.email}</CustomerEmail>
                                                                                 <CustomerEmployer>${this.spanishConvert.removeDiacritics(user.employess, true)}</CustomerEmployer>
                                                                                 <CustomerOccupation>${user.occupation}</CustomerOccupation>
                                                                                 <DOB>${user.dob}</DOB>
                                                                                 <FirstName>${this.spanishConvert.removeDiacritics(this.utilserv.isNull(user.firstName.trim()), true)}</FirstName>
                                                                                 <KeyUID>${sessionStorage.KeyUID}</KeyUID>
                                                                                 <LanguageCode>${this.utilserv.isNull(sessionStorage.langCode)}</LanguageCode>
                                                                                 <LastName>${this.spanishConvert.removeDiacritics(this.utilserv.isNull(user.lastName.trim()), true)}</LastName>
                                                                                 <LoyaltyCardNumber>${sessionStorage.loyaltyCardNumber != undefined ? sessionStorage.loyaltyCardNumber : ''
        }</LoyaltyCardNumber>
                                                                                 <MiddleName>${user.middleName}</MiddleName>
                                                                                 <MobileNumber>${user.mobile}</MobileNumber>
                                                                                 <PreferCountryCode>${user.countryPreference}</PreferCountryCode>
                                                                                 <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common.Contract" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                                                                   <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
                                                                                   <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                                                                                 </Session>
                                                                                 <UserID>${this.utilserv.isNull(user.UserID)}</UserID>
                                                                                 <UserVerifiedBy>${this.utilserv.isNull(user.UserVerifiedBy)}</UserVerifiedBy>
                                                                               </CustomerInfoRequest>
                                                                             </s:Body>
                                                                           </s:Envelope>`;

      //console.log(envelope);

      return envelope;
    }
  }
  private envelopEditUseruploadImage(user: User): string {
    let envelope: string = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing"
                                     xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                                    <s:Header>
                                            <a:Action s:mustUnderstand="1">http://tempuri.org/IICEUserMgmt/UploadProfileImage</a:Action>
                                            <a:MessageID>urn:uuid:7ff2e128-e4e2-496e-a56b-b8c62b324dc9</a:MessageID>
                                            <a:ReplyTo>
                                               <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                                            </a:ReplyTo>
                                    </s:Header>
                                    <s:Body>
                                        <UploadImage xmlns="http://tempuri.org/">
                                        <ImageData>${user.UserProfileImageBase64}</ImageData>
                                        <ImageName>web</ImageName>
                                        <ImageType>USERPROFILE</ImageType>
                                        <KeyUID>${sessionStorage.KeyUID}</KeyUID>
                                        <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                                        <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common.Contract" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                            <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
                                            <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                                        </Session>
                                        </UploadImage>
                                    </s:Body>
                            </s:Envelope>`;

    return envelope;
  }
  private envelopGetUserImage(): string {
    const DeviceDetail = this.deviceService.getDeviceInfo();
    this.userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      this.userGioLocation = data;
    });
    let envelope: string = `
                 <s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                    <s:Header>
                        <a:Action s:mustUnderstand="1">http://tempuri.org/IICEDocumentMgmt/GetMyDocuments</a:Action>
                        <a:MessageID>urn:uuid:0ccac42b-a256-4ced-89bb-d801946dabde</a:MessageID>
                        <a:ReplyTo>
                        <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                        </a:ReplyTo>
                    </s:Header>
                    <s:Body>
                        <RequestBase xmlns="http://tempuri.org/">
                        <DeviceDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                          <d4p1:Appversion>${AppSettings.Appversion}</d4p1:Appversion>
                          <d4p1:DeviceBrowser>${DeviceDetail.browser}</d4p1:DeviceBrowser>
                          <d4p1:DeviceID>${localStorage.sessionId}</d4p1:DeviceID>
                          <d4p1:DeviceOS>${DeviceDetail.os}</d4p1:DeviceOS>
                          <d4p1:DeviceOS_version>${DeviceDetail.os_version}</d4p1:DeviceOS_version>
                          <d4p1:DeviceType>${DeviceDetail.device}</d4p1:DeviceType>
                          <d4p1:DeviceUserAgent>${DeviceDetail.userAgent}</d4p1:DeviceUserAgent>
                          <d4p1:EndIPAddress>${sessionStorage.EndUserIP}</d4p1:EndIPAddress>
                          <d4p1:Latitude>${this.userGioLocation.latitude}</d4p1:Latitude>
                          <d4p1:Longitude>${this.userGioLocation.longitude}</d4p1:Longitude>
                          <d4p1:Platform>${AppSettings.Platform}</d4p1:Platform>
                        </DeviceDetails>
                        <LanguageCode>${this.utilserv.isNull(sessionStorage.langCode)}</LanguageCode>
                        <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.DocumentManagement.Common.Contract" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                        <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
                        <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                        </Session>
                        </RequestBase>
                    </s:Body>
                    </s:Envelope>`;

    return envelope;
  }

  verifyUserMobile(model: any) {
    return this.utilserv.soapPostwithoutAction(this.envelopVerifyUserMobileForRegistration(model), AppSettings.ICEUserMgmtService);
  }
  private envelopVerifyUserMobileForRegistration(model: any) {

    const DeviceDetail = this.deviceService.getDeviceInfo();
    let userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      userGioLocation = data;
    });
    const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
    <s:Header>
      <a:Action s:mustUnderstand="1">http://tempuri.org/IICEUserMgmt/VerifyEmailAndPhoneOTP</a:Action>
      <a:MessageID>urn:uuid:40109db5-520f-4e44-8d4d-033714bc979e</a:MessageID>
      <a:ReplyTo>
        <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
      </a:ReplyTo>
    </s:Header>
    <s:Body>
      <ValidateOTP xmlns="http://tempuri.org/">
      <DeviceDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
        <d4p1:Appversion>${AppSettings.Appversion}</d4p1:Appversion>
        <d4p1:DeviceBrowser>${DeviceDetail.browser}</d4p1:DeviceBrowser>
        <d4p1:DeviceID>${localStorage.sessionId}</d4p1:DeviceID>
        <d4p1:DeviceOS>${DeviceDetail.os}</d4p1:DeviceOS>
        <d4p1:DeviceOS_version>${DeviceDetail.os_version}</d4p1:DeviceOS_version>
        <d4p1:DeviceType>${DeviceDetail.device}</d4p1:DeviceType>
        <d4p1:DeviceUserAgent>${DeviceDetail.userAgent}</d4p1:DeviceUserAgent>
        <d4p1:EndIPAddress>${sessionStorage.EndUserIP}</d4p1:EndIPAddress>
        <d4p1:Latitude>${userGioLocation.latitude}</d4p1:Latitude>
        <d4p1:Longitude>${userGioLocation.longitude}</d4p1:Longitude>
        <d4p1:Platform>${AppSettings.Platform}</d4p1:Platform>
      </DeviceDetails>
        <EmailOTP>${this.utilserv.getObjectText(model.mailOTP)}</EmailOTP>
        <KeyUID>${this.utilserv.isNull(sessionStorage.KeyUID)}</KeyUID>
        <LanguageCode>${sessionStorage.langCode}</LanguageCode>
        <LoyaltyCardNumber></LoyaltyCardNumber>
        <MethodName>${model.MethodName}</MethodName>
        <MobileNumber>${model.MobileNumber}</MobileNumber>
        <OTP>${model.txtOTP}</OTP>
        <RegistrationCode></RegistrationCode>
        <UserID>${model.UserID}</UserID>
      </ValidateOTP>
    </s:Body>
  </s:Envelope>`;

    return envelope;
  }

  private envelopVerifyUserMobile(model: any, user: User) {
    // let envelope: string = `<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">
    //               <s:Header>
    //                 <Action s:mustUnderstand="1" xmlns="http://schemas.microsoft.com/ws/2005/05/addressing/none">http://tempuri.org/IICEUserMgmt/VerifyEmailAndPhoneOTP</Action>
    //               </s:Header>
    //               <s:Body>
    //                       <ValidateOTP>
    //                         <KeyUID>${this.utilserv.isNull(sessionStorage.KeyUID)}</KeyUID>
    //                         <LanguageCode>${this.utilserv.isNull(sessionStorage.langCode)}</LanguageCode>
    //                         <LoyaltyCardNumber></LoyaltyCardNumber>
    //                         <MethodName>SMS</MethodName>
    //                         <MobileNumber>${user.mobile}</MobileNumber>
    //                         <OTP>${model.txtOTP}</OTP>
    //                         <RegistrationCode>${this.utilserv.isNull(user.RegistrationCode)}</RegistrationCode>
    //                         <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common.Contract" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
    //                             <d4p1:T1></d4p1:T1>
    //                     <d4p1:T2></d4p1:T2>
    //                         </Session>
    //                         <UserID>${this.utilserv.isNull(user.UserID)}</UserID>
    //                       </ValidateOTP>
    //                 </s:Body>
    //             </s:Envelope>`;
    // return envelope;
    const DeviceDetail = this.deviceService.getDeviceInfo();
    let userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      userGioLocation = data;
    });
    let envelope: string = `<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">
                            <s:Header>
                              <Action s:mustUnderstand="1" xmlns="http://schemas.microsoft.com/ws/2005/05/addressing/none">
                                  http://tempuri.org/IICEUserMgmt/GenerateOTPValue
                              </Action>
                            </s:Header>
                            <s:Body>
                              <GenerateOTP xmlns="http://tempuri.org/">
                              <DeviceDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                  <d4p1:Appversion>${AppSettings.Appversion}</d4p1:Appversion>
                                  <d4p1:DeviceBrowser>${DeviceDetail.browser}</d4p1:DeviceBrowser>
                                  <d4p1:DeviceID>${localStorage.sessionId}</d4p1:DeviceID>
                                  <d4p1:DeviceOS>${DeviceDetail.os}</d4p1:DeviceOS>
                                  <d4p1:DeviceOS_version>${DeviceDetail.os_version}</d4p1:DeviceOS_version>
                                  <d4p1:DeviceType>${DeviceDetail.device}</d4p1:DeviceType>
                                  <d4p1:DeviceUserAgent>${DeviceDetail.userAgent}</d4p1:DeviceUserAgent>
                                  <d4p1:EndIPAddress>${sessionStorage.EndUserIP}</d4p1:EndIPAddress>
                                  <d4p1:Latitude>${userGioLocation.latitude}</d4p1:Latitude>
                                  <d4p1:Longitude>${userGioLocation.longitude}</d4p1:Longitude>
                                  <d4p1:Platform>${AppSettings.Platform}</d4p1:Platform>
                                </DeviceDetails>
                                <KeyUID>${this.utilserv.isNull(sessionStorage.KeyUID)}</KeyUID>
                                <LanguageCode>${this.utilserv.isNull(sessionStorage.langCode)}</LanguageCode>
                                <MethodName>SMS</MethodName>
                                <OTPName>USEr</OTPName>
                                <OTPValue>${model.txtOTP}</OTPValue>
                                <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common.Contract"
                                 xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                  <d4p1:T1></d4p1:T1>
                                  <d4p1:T2></d4p1:T2>
                                </Session>
                              </GenerateOTP>
                            </s:Body>
                          </s:Envelope>`;

    return envelope;
  }

  private envelopGenerateUserMobileOTP(user: User) {
    let envelope: string = `<soapenv:Envelope xmlns:soapenv=\"http://schemas.xmlsoap.org/soap/envelope/\" xmlns:tem=\"http://tempuri.org/\">
            \n   <soapenv:Header/> \
            \n   <soapenv:Body> \
            \n      <tem:GenerateOTP> \
            \n         <tem:MethodName>${user}</tem:MethodName> \
            \n         <tem:OTPName>${user}</tem:OTPName> \
            \n         <tem:OTPValue>${user}</tem:OTPValue> \
            \n      </tem:GenerateOTP> \
            \n   </soapenv:Body> \
            \n</soapenv:Envelope>`;
    return envelope;
  }

  // private helper methods
  private jwt() {
    // create authorization header with jwt token
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    if (currentUser && currentUser.token) {
      let headers = new Headers({ Authorization: 'Bearer ' + currentUser.token });
      return new RequestOptions({ headers: headers });
    }
  }
  private handleError(error: any) {
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/userservice/user.service.ts